<template>
  <div>
    <b-alert variant="danger"
             class="p-5"
             dismissible
             :show="error.isVisible"
             @dismissed="error.isVisible=false">
      {{ error.message }}
    </b-alert>
    <b-card class="rounded-0">
      <h4>{{ $t('message.resetPassword.title') }}</h4>
      <p>{{ $t('message.resetPassword.message') }}</p>
      <b-form @submit.prevent="submit">
        <b-form-row class="mt-3">
          <b-col>
            <b-form-group :state="$v.email.$error ? false : null"
                          :invalid-feedback="invalidEmail">
              <b-form-input v-model="email"
                            :placeholder="$t('message.resetPassword.input.email.placeholder')"
                            :state="$v.email.$error ? false : null"
                            @change="$v.email.$touch()">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="mt-4">
          <b-col>
            <b-btn variant="link" @click="back">{{ $t('message.resetPassword.btn.back') }}</b-btn>
          </b-col>
          <b-col class="text-right">
            <b-btn variant="primary" type="submit">{{ $t('message.resetPassword.btn.send') }}</b-btn>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
  import { email, required } from 'vuelidate/lib/validators'

  export default {
    computed: {
      invalidEmail () {
        return this.$t('error.resetPassword.email')
      }
    },
    data () {
      return {
        email: null,
        error: {
          isVisible: false
        }
      }
    },
    methods: {
      back () {
        this.$router.back()
      },
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.$store.dispatch('resetPassword', this.email)
            .then(() => this.$router.push({ path: '/resetPassword/confirm', query: { email: this.email } }))
            .catch(() => {
              this.error.message = this.$t('error.resetPassword.submit', { email: this.email })
              this.error.isVisible = true
            })
        }
      }
    },
    validations: {
      email: {
        email,
        required
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/ResetPassword.vue